import { render, staticRenderFns } from "./_ConfirmedChip.vue?vue&type=template&id=e5b641ce"
import script from "./_ConfirmedChip.vue?vue&type=script&lang=js"
export * from "./_ConfirmedChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports